import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Button, IconButton, Grid, Tooltip, TextField } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import { withRouter } from 'react-router-dom';
import AssetPreview from './AssetPreview';
import AssetUpload from '../asset/AssetUpload';
import classNames from 'classnames';
import TableCellTooltip from '../../components/TableCellTooltip';
import { getSharedTextFieldProps } from '../../components/helpers';

let moment = require('moment');

const styles = theme => ({
    spacer: {
        marginTop: 25
    },
    active: {
        backgroundColor: 'yellow',
        borderRadius: 25
    },
    resize: {
        fontSize: '12px',
        height: '45px'
    }
});

class ModelAssetList extends Component {

    state = {
        preview: false,
        preview_id: null,
        preview_type: null,
        preview_url: null,
        fullPagePreview: false
    }

    constructor(props) {
        super(props);
    }

    handleLeaveFullPage = () => {
        this.setState({ fullPagePreview: false })
    };

    handleRowClick(page_type, asset_id, asset_URL, asset_format) {
        this.setState({ preview: true, preview_id: asset_id, preview_url: asset_URL, preview_type: asset_format, fullPagePreview: true }, () => {
        })
    };

    handleRowHover(page_type, asset_id, asset_URL, asset_format) {
        this.setState({ preview: true, preview_id: asset_id, preview_url: asset_URL, preview_type: asset_format }, () => {
        })
    };

    getFormatColumn = (asset) => {
        if (asset.original_asset_id != 0) {
            return `${asset.AssetFormat} (${asset.OriginalAssetFormat})`
        }
        return asset.AssetFormat
    };

    updateAssetName = (e, asset_id, saved) => {
        this.props.updateAssetNameFunc(e, asset_id, saved);
    }

    saveAssetName = (row) => {
        this.props.updateAssetNameFunc(row.AssetNewName, row.asset_id, true)
        this.props.saveAssetName(row)
    }

    viewColumn = (asset) => {
        if (asset.OriginalURL) {
            return (
                <Tooltip
                    title={`View/Download original asset`}
                    enterDelay={100}
                >
                    <IconButton
                        // onClick={() =>this.props.history.push('/' + asset.URL)}
                        href={asset.OriginalURL}
                    >
                        <Icon>backup</Icon>
                    </IconButton>
                </Tooltip>
            )
        }
        return null
    }

    getSaveDiv = (row) => {
        if (row.AssetNewName === row.UneditedNewName) {
            return null
        }
        return (
            <div>
                <IconButton
                    onClick={() => this.saveAssetName(row)}
                >
                    <Icon>check</Icon>
                </IconButton>
                <IconButton
                    onClick={() => this.updateAssetName(row.UneditedNewName, row.asset_id, false)}
                >
                    <Icon>clear</Icon>
                </IconButton>
            </div>
        )
    }

    getPreviewRow = (row) => {
        const preview = [
            'jpg', 'jpeg', 'png', 'svg', 'gif', 'tiff', 'bmp',
            'mp4', 'mp3', 'mov', 'avi', 'wmv',
            'pdf', 'doc', 'docx', 'csv',
            'ppt', 'pptx', 'odp'
        ]
        if (!preview.includes(row.original.AssetFormat)) {
            return (
                <div className={"flex items-center"} >
                    <Icon style={{ color: 'lightgrey', padding: '0px', marginLeft: '5px', marginRight: '5px' }}>pageview</Icon>
                </div>
            )
        }
        return (
            <div className={"flex items-center " + (this.state.preview_id === row.original.asset_id ? classNames(this.props.classes.active) : 'none')} >
                <IconButton
                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                    onClick={(ev) => {
                        ev.stopPropagation();
                        this.handleRowClick('preview', row.original.asset_id, row.original.URL, row.original.AssetFormat);
                    }}
                    onMouseOver={() => this.handleRowHover('preview', row.original.asset_id, row.original.URL, row.original.AssetFormat)}
                >
                    <Icon>pageview</Icon>

                </IconButton>
            </div>
        )
    }

    getColumnList = () => {
        const { classes, view_type } = this.props;

        let nameCol = view_type === 'detail' ?
            {
                Header: "Asset Name",
                Cell: row => (
                    <TableCellTooltip
                        item={row.original.AssetNewName}
                        chars={20}
                    />
                )
            }
            :
            {
                Header: "Asset Name",
                Cell: row => (
                    <React.Fragment>
                        <TextField
                            id="AssetNewName"
                            value={row.original.AssetNewName}
                            onChange={(e) => this.updateAssetName(e.target.value, row.original.asset_id, false)}
                            style={{ minWidth: '250px' }}
                            InputProps={{ classes: { input: classes.resize } }}
                            variant={'outlined'}
                        // {...getSharedTextFieldProps(view_type, classes)}
                        // className={(assignment.header.AssignmentDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                        // multiline
                        // rows="4"
                        />
                        {this.getSaveDiv(row.original)}
                    </React.Fragment>

                )
            }

        let column_list =
            [
                {
                    Header: "Preview",
                    width: 80,
                    Cell: row => (
                        this.getPreviewRow(row)
                    )
                },
                nameCol,
                {
                    Header: "Type (Orig)",
                    accessor: a => this.getFormatColumn(a),
                    id: 'AssetFormat',
                    width: 80
                },
                {
                    Header: "Uploaded Date",
                    id: "CreationDate",
                    accessor: a => moment(a.CreationDate).format('MM-DD-YYYY'),
                    width: 120
                },
                {
                    Header: "Uploaded User",
                    id: "UploadedUser",
                    accessor: "UploadedUser",
                    width: 175
                },
                {
                    Header: "",
                    id: "ViewDownload",
                    accessor: a => this.viewColumn(a),
                    width: 60,
                }
            ];

        if (view_type !== 'detail') {
            column_list.push(
                {
                    Header: "Delete",
                    id: "Delete",
                    width: 60,
                    accessor: a =>
                        <div className="flex items-center">
                            <IconButton
                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.props.deleteAsset(a.asset_id, this.props.model_type, this.props.model_id, this.props.getAssetList);
                                    this.setState({ preview_id: null, preview_url: null, preview_type: null })
                                }}
                            >
                                <Icon>delete</Icon>
                            </IconButton>
                        </div>
                }
            );
        }

        return column_list
    }

    render() {

        const { classes, assetList, view_type } = this.props;
        const normalized_assetList = assetList.map((asset) => asset.header);
        const column_list = this.getColumnList();

        if (this.state.fullPagePreview) {
            return (
                <div style={{ height: '100vh' }}>
                    <Button
                        id="testButton"
                        onClick={this.handleLeaveFullPage}
                        variant="contained"
                    >
                        Back
                    </Button>
                    <AssetPreview asset_id={this.state.preview_id} asset_url={this.state.preview_url} asset_format={this.state.preview_type} full_page={true} />
                </div>

            )
        }
        else {
            return (
                <div className="px-24">
                    <Grid container spacing={24}>
                        <Grid item xs={3}>
                            {this.preview(this.state.preview_id, this.state.preview_type)}
                            <div className={classNames(classes.spacer)}>
                                {view_type !== 'detail' ?
                                    <AssetUpload
                                        file_type={this.props.file_type}
                                        auth_id={this.props.auth.user.data.auth_id}
                                        modelType={this.props.model_type}
                                        model_id={this.props.model_id}
                                        requires_relation={true}
                                        getAssetList={this.props.getAssetList}
                                    /> : ''
                                }
                            </div>
                        </Grid>
                        <Grid item xs={9}>
                            <ReactTable
                                columns={column_list}
                                data={normalized_assetList}
                                defaultPageSize={25}
                                className="-striped -highlight"
                                noDataText="No Assets Found"
                            />
                        </Grid>
                    </Grid>
                </div>
            )
        }

    }
    preview = (prop) => {
        return prop ?
            <div>
                <AssetPreview asset_id={this.state.preview_id} asset_url={this.state.preview_url} asset_format={this.state.preview_type} full_page={false} />
            </div> :
            <div>
                <h3>Preview</h3>  <img src='assets/images/logos/photo-camera.jpg' />
            </div>
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // getAssetList: Actions.getModelAssetList,
        saveAssetName: Actions.saveAssetName,
        deleteAsset: Actions.deleteAsset
    }, dispatch);
}

function mapStateToProps({ assetApp, auth }) {
    return {
        // assetList: assetApp.assets.assetList,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModelAssetList)));


// WEBPACK FOOTER //
// src/main/content/asset/ModelAssetList.js